import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { firestorePlugin } from 'vuefire';
import InstantSearch from 'vue-instantsearch';
import moment from 'moment';
import 'moment/locale/ja';
import * as VueMoment from 'vue-moment';
import VueGtag from "vue-gtag";
import VueShareSocial from 'vue-share-social';
import VueYouTubeEmbed from 'vue-youtube-embed';
import linkify from 'vue-linkify';


Vue.directive('linkified', linkify);
Vue.use(VueShareSocial);
Vue.use(VueYouTubeEmbed);
Vue.use(VueGtag, {
  config: { id: "G-VS6HY1PP62" }
}, router);
Vue.use(InstantSearch);
Vue.use(firestorePlugin);
Vue.use(VueMoment, { moment });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
"";